import { createSelector } from '@ngrx/store';

import { onlineMenuFiltersState } from '../root';

export const getOnlineMenuFiltersSearchInput = createSelector(onlineMenuFiltersState, (onlineMenuFilters) => onlineMenuFilters?.search || null);
